import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { FormModule } from '@shared/components/form/form.module';
import { AlertComponent } from '@shared/components/alert/alert.component';

@NgModule({
  imports: [CommonModule, TranslateModule, FormModule, AlertComponent],
  exports: [AlertComponent]
})
export class AlertModule {}
